export default __webpack_public_path__ + "static/media/ledIcon.9519f976.svg";